"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeKeys = exports.isValidWeakMapKey = exports.mergeCustomizations = exports.createLinkFn = void 0;

var interfaces_1 = require("../interfaces");

var weak_map_1 = require("./weak-map");

var react_1 = require("react");

var flags_1 = require("../flags");

var hook_1 = require("../classes/hook");

var _1 = require(".");

var defaultLintMapContainer = new weak_map_1.MultiDimentionalWeakMap(3);
var linkingMergeFlags = [flags_1.CustoMergeFlagEnum.linking];

exports.createLinkFn = function (_a) {
  var flags = _a.flags,
      avoidMergingClassesIfExplicitelySet = _a.avoidMergingClassesIfExplicitelySet,
      _b = _a.lintMapContainer,
      lintMapContainer = _b === void 0 ? defaultLintMapContainer : _b;
  var mergedFlags = flags_1.getMemoizedFlags(__spread(flags, linkingMergeFlags));

  var link = function link(obj1, obj2, key) {
    if (obj2[key] === undefined || obj2[key] === null) {
      obj2[key] = obj1;
      return;
    }

    var propsAreValidKeys = exports.isValidWeakMapKey(obj1) && exports.isValidWeakMapKey(obj2[key]);
    var memoKeys = [mergedFlags, obj2[key], obj1];

    if (propsAreValidKeys) {
      var memoizedValue = lintMapContainer.get(memoKeys);

      if (memoizedValue) {
        obj2[key] = memoizedValue;
        return;
      }
    }

    if (isComponentHook(obj1) || isComponentHook(obj2[key])) {
      if (avoidMergingClassesIfExplicitelySet) return;
      obj2[key] = mergeCustoClasses(obj2[key], obj1, "overrideLeftToRight", mergedFlags);

      if (propsAreValidKeys) {
        lintMapContainer.set(memoKeys, obj2[key]);
      }

      return;
    }

    if (typeof obj1 !== "object" || obj1 === null) return;

    if (_1.isCustoClass(obj1) && _1.isCustoClass(obj2[key])) {
      if (avoidMergingClassesIfExplicitelySet) return;
      obj2[key] = mergeCustoClasses(obj2[key], obj1, "overrideLeftToRight", mergedFlags);

      if (propsAreValidKeys) {
        lintMapContainer.set(memoKeys, obj2[key]);
      }

      return;
    }

    for (var k in obj1) {
      link(obj1[k], obj2[key], k);
    }
  };

  return link;
};

var mergeCustoClasses = function mergeCustoClasses(left, right, mergeStrategy, mergeFlags) {
  if (isComponentHook(left) || isComponentHook(right)) {
    var dHook = hook_1.CustoHook.createComponentHook(function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var first = left instanceof hook_1.CustoHook ? left.use.apply(left, __spread(args)) : left;
      var second = right instanceof hook_1.CustoHook ? right.use.apply(right, __spread(args)) : right;
      var value = react_1.useMemo(function () {
        if (_1.isCustoClass(first) && _1.isCustoClass(second)) {
          return mergeCustoClasses(first, second, mergeStrategy, mergeFlags);
        }

        if (mergeStrategy === "overrideLeftToRight") {
          return first !== null && first !== void 0 ? first : second;
        } else if (mergeStrategy === "overrideRightToLeft") {
          return second !== null && second !== void 0 ? second : first;
        }
      }, [first, second]);
      return value;
    });
    var isLeftSafe = left instanceof hook_1.CustoHook ? left.isSafe : true;
    var isRightSafe = right instanceof hook_1.CustoHook ? right.isSafe : true;

    if (isLeftSafe && isRightSafe) {
      return dHook.getFuncVersion();
    }

    return dHook;
  }

  if (mergeStrategy === "overrideLeftToRight") {
    if (left.mergeClass) return left.mergeClass(right, mergeFlags);
    return left;
  }

  if (mergeStrategy === "overrideRightToLeft") {
    if (right.mergeClass) return right.mergeClass(left, mergeFlags);
    return right;
  }

  throw new Error("incorrect mergeStrategy passed");
};

var isComponentHook = function isComponentHook(val) {
  return val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.component;
};

function mergeCustomizations(_a) {
  var object1 = _a.object1,
      object2 = _a.object2,
      memoContainer = _a.memoContainer,
      mergeStrategy = _a.mergeStrategy,
      _b = _a.avoidCustomizationsMerging,
      avoidCustomizationsMerging = _b === void 0 ? false : _b,
      mergeFlags = _a.mergeFlags,
      _c = _a.path,
      path = _c === void 0 ? "" : _c,
      decisionFn = _a.decisionFn;
  var memoKey1 = getObjByMergeStrategy(mergeStrategy);
  var memoKey2 = getObjByMergingAvoidance(avoidCustomizationsMerging);
  var prefixKeys = [memoKey1, memoKey2];

  var memoKeys = __spread(prefixKeys, [object1, object2]);

  var originalObjectsAreValidKeys = exports.isValidWeakMapKey(object1) && exports.isValidWeakMapKey(object2);

  if (originalObjectsAreValidKeys) {
    var memoizedValue = memoContainer.get(memoKeys);
    if (memoizedValue) return memoizedValue;
  }

  var obj1 = __assign({}, object1);

  for (var p in object2) {
    var propPath = (path ? path + "." : "") + p;
    if (!object2.hasOwnProperty(p)) continue;
    if (object2[p] === obj1[p]) continue;

    if (!obj1.hasOwnProperty(p)) {
      if (object2[p] !== undefined) {
        obj1[p] = object2[p];
      }

      continue;
    }

    if (decisionFn) {
      var skip = decisionFn(propPath, object1, object2).skip;
      if (skip) continue;
    }

    var propsAreValidKeys = exports.isValidWeakMapKey(obj1[p]) && exports.isValidWeakMapKey(object2[p]);

    var propMemoKeys = __spread(prefixKeys, [obj1[p], object2[p]]);

    if (propsAreValidKeys) {
      var memoizedPropValue = memoContainer.get(propMemoKeys);

      if (memoizedPropValue) {
        obj1[p] = memoizedPropValue;
        continue;
      }
    }

    if (_1.isCustoClass(object2[p]) && _1.isCustoClass(obj1[p]) && !avoidCustomizationsMerging) {
      obj1[p] = mergeCustoClasses(obj1[p], object2[p], mergeStrategy, mergeFlags);
    } else if (object2[p].constructor === Object && !_1.isCustoClass(obj1[p]) && !_1.isCustoClass(object2[p])) {
      obj1[p] = mergeCustomizations({
        object1: obj1[p],
        object2: object2[p],
        memoContainer: memoContainer,
        mergeStrategy: mergeStrategy,
        avoidCustomizationsMerging: avoidCustomizationsMerging,
        mergeFlags: mergeFlags,
        path: propPath,
        decisionFn: decisionFn
      });
    } else {
      if (mergeStrategy === "overrideLeftToRight") {
        if (!obj1.hasOwnProperty(p)) {
          obj1[p] = object2[p];
        }
      } else if (mergeStrategy === "overrideRightToLeft") {
        obj1[p] = object2[p];
      }
    }

    if (obj1[p] === undefined) delete obj1[p];

    if (propsAreValidKeys) {
      memoContainer.set(propMemoKeys, obj1[p]);
    }
  }

  if (originalObjectsAreValidKeys) {
    memoContainer.set(memoKeys, obj1);
  }

  return obj1;
}

exports.mergeCustomizations = mergeCustomizations;

exports.isValidWeakMapKey = function (val) {
  if (!val) return false;
  return typeof val === "object" || typeof val === "function";
};

var mergeStrategyLeftToRight = {
  mergeStrategy: "overrideLeftToRight"
};
var mergeStrategyRightToLeft = {
  mergeStrategy: "overrideRightToLeft"
};

var getObjByMergeStrategy = function getObjByMergeStrategy(mergeStrategy) {
  if (mergeStrategy === "overrideLeftToRight") {
    return mergeStrategyLeftToRight;
  }

  if (mergeStrategy === "overrideRightToLeft") {
    return mergeStrategyRightToLeft;
  }

  throw new Error("incorrect mergeStrategy passed");
};

var mergingAvoidanceAvoid = {
  avoidCustomizationsMerging: true
};
var mergingAvoidanceDoNotAvoid = {
  avoidCustomizationsMerging: false
};

var getObjByMergingAvoidance = function getObjByMergingAvoidance(avoidCustomizationsMerging) {
  if (avoidCustomizationsMerging) {
    return mergingAvoidanceAvoid;
  }

  return mergingAvoidanceDoNotAvoid;
};

function removeKeys(obj) {
  var keys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    keys[_i - 1] = arguments[_i];
  }

  var obj2 = __assign({}, obj);

  for (var i = 0; i < keys.length; ++i) {
    delete obj2[keys[i]];
  }

  return obj2;
}

exports.removeKeys = removeKeys;